// Version : 0.0.1
// Author :AGALYA

import AuditingToolActionTypes from './auditing-tool.types';

/** ***************** GET AUDITING TOOL LIST START *********************** */
export const getAuditingToolDetailsStart = (getData: any) => ({
	type: AuditingToolActionTypes.GET_AUDITING_TOOL_LIST_START,
	payload: getData,
});

export const getAuditingToolDetailsSuccess = (successData: any) => ({
	type: AuditingToolActionTypes.GET_AUDITING_TOOL_LIST_SUCCESS,
	payload: successData,
});

export const getAuditingToolDetailsFailure = (failureData: any) => ({
	type: AuditingToolActionTypes.GET_AUDITING_TOOL_LIST_FAILURE,
	payload: failureData,
});

export const getAuditingToolDetailsResponseResetStart = () => ({
	type: AuditingToolActionTypes.GET_AUDITING_TOOL_LIST_RESPONSE_RESET,
});

export const getAuditingToolDetailsResponseChanged = () => ({
	type: AuditingToolActionTypes.GET_AUDITING_TOOL_LIST_RESPONSE_CHANGED,
});
/** ***************** GET AUDITING TOOL LIST END *********************** */

/** ***************** FETCH AUDITING TOOL START *********************** */
export const fetchAuditingToolDetailsStart = (getData: any) => ({
	type: AuditingToolActionTypes.FETCH_AUDITING_TOOL_LIST_START,
	payload: getData,
});

export const fetchAuditingToolDetailsSuccess = (successData: any) => ({
	type: AuditingToolActionTypes.FETCH_AUDITING_TOOL_LIST_SUCCESS,
	payload: successData,
});

export const fetchAuditingToolDetailsFailure = (failureData: any) => ({
	type: AuditingToolActionTypes.FETCH_AUDITING_TOOL_LIST_FAILURE,
	payload: failureData,
});

export const fetchAuditingToolDetailsReset = () => ({
	type: AuditingToolActionTypes.FETCH_AUDITING_TOOL_LIST_RESET,
});

export const fetchAuditingToolDetailsChanged = () => ({
	type: AuditingToolActionTypes.FETCH_AUDITING_TOOL_LIST_CHANGED,
});
/** *****************  FETCH AUDITING TOOL END *********************** */

/** ***************** GET QUESTIONNAIRE START *********************** */
export const getQuestionnaireStart = (getData: any) => ({
	type: AuditingToolActionTypes.GET_QUESTIONNAIRE_START,
	payload: getData,
});

export const getQuestionnaireSuccess = (successData: any) => ({
	type: AuditingToolActionTypes.GET_QUESTIONNAIRE_SUCCESS,
	payload: successData,
});

export const getQuestionnaireFailure = (failureData: any) => ({
	type: AuditingToolActionTypes.GET_QUESTIONNAIRE_FAILURE,
	payload: failureData,
});

export const getQuestionnaireResponseResetStart = () => ({
	type: AuditingToolActionTypes.GET_QUESTIONNAIRE_RESPONSE_RESET,
});

export const getQuestionnaireResponseChanged = () => ({
	type: AuditingToolActionTypes.GET_QUESTIONNAIRE_RESPONSE_CHANGED,
});
/** ***************** GET QUESTIONNAIRE END *********************** */

/** ***************** GET TRAINING PROPOSAL MEMBERS START *********************** */
export const getTrainingProposalMembersStart = (getData: any) => ({
	type: AuditingToolActionTypes.GET_TRAINING_PROPOSAL_MEMBERS_START,
	payload: getData,
});

export const getTrainingProposalMembersSuccess = (successData: any) => ({
	type: AuditingToolActionTypes.GET_TRAINING_PROPOSAL_MEMBERS_SUCCESS,
	payload: successData,
});

export const getTrainingProposalMembersFailure = (failureData: any) => ({
	type: AuditingToolActionTypes.GET_TRAINING_PROPOSAL_MEMBERS_FAILURE,
	payload: failureData,
});

export const getTrainingProposalMembersReset = () => ({
	type: AuditingToolActionTypes.GET_TRAINING_PROPOSAL_MEMBERS_RESET,
});

export const getTrainingProposalMembersChanged = () => ({
	type: AuditingToolActionTypes.GET_TRAINING_PROPOSAL_MEMBERS_CHANGED,
});
/** ***************** GET TRAINING PROPOSAL MEMBERS END *********************** */

/** ***************** ADD TRAINING PROPOSAL START *********************** */
export const addTrainingProposalStart = (addData: any) => ({
	type: AuditingToolActionTypes.ADD_TRAINING_PROPOSAL_START,
	payload: addData,
});

export const addTrainingProposalSuccess = (successData: any) => ({
	type: AuditingToolActionTypes.ADD_TRAINING_PROPOSAL_SUCCESS,
	payload: successData,
});

export const addTrainingProposalFailure = (failureData: any) => ({
	type: AuditingToolActionTypes.ADD_TRAINING_PROPOSAL_FAILURE,
	payload: failureData,
});

export const addTrainingProposalReset = () => ({
	type: AuditingToolActionTypes.ADD_TRAINING_PROPOSAL_RESET,
});

export const addTrainingProposalChanged = () => ({
	type: AuditingToolActionTypes.ADD_TRAINING_PROPOSAL_CHANGED,
});
/** ***************** ADD TRAINING PROPOSAL END *********************** */

/** ***************** UPDATE TRAINING PROPOSAL START *********************** */
export const updateTrainingProposalStart = (updateData: any) => ({
	type: AuditingToolActionTypes.UPDATE_TRAINING_PROPOSAL_START,
	payload: updateData,
});

export const updateTrainingProposalSuccess = (successData: any) => ({
	type: AuditingToolActionTypes.UPDATE_TRAINING_PROPOSAL_SUCCESS,
	payload: successData,
});

export const updateTrainingProposalFailure = (failureData: any) => ({
	type: AuditingToolActionTypes.UPDATE_TRAINING_PROPOSAL_FAILURE,
	payload: failureData,
});

export const updateTrainingProposalReset = () => ({
	type: AuditingToolActionTypes.UPDATE_TRAINING_PROPOSAL_RESET,
});

export const updateTrainingProposalChanged = () => ({
	type: AuditingToolActionTypes.UPDATE_TRAINING_PROPOSAL_CHANGED,
});
/** ***************** UPDATE TRAINING PROPOSAL END *********************** */

/** ***************** DELETE TRAINING PROPOSAL START *********************** */
export const deleteTrainingProposalStart = (deleteData: any) => ({
	type: AuditingToolActionTypes.DELETE_TRAINING_PROPOSAL_START,
	payload: deleteData,
});

export const deleteTrainingProposalSuccess = (successData: any) => ({
	type: AuditingToolActionTypes.DELETE_TRAINING_PROPOSAL_SUCCESS,
	payload: successData,
});

export const deleteTrainingProposalFailure = (failureData: any) => ({
	type: AuditingToolActionTypes.DELETE_TRAINING_PROPOSAL_FAILURE,
	payload: failureData,
});

export const deleteTrainingProposalReset = () => ({
	type: AuditingToolActionTypes.DELETE_TRAINING_PROPOSAL_RESET,
});

export const deleteTrainingProposalChanged = () => ({
	type: AuditingToolActionTypes.DELETE_TRAINING_PROPOSAL_CHANGED,
});
/** ***************** DELETE TRAINING PROPOSAL END *********************** */

/** ***************** GET SUPERVISER LIST START *********************** */
export const getAllSuperviserListStart = (addData: any) => ({
	type: AuditingToolActionTypes.GET_ALL_SUPERVISER_LIST_START,
	payload: addData,
});

export const getAllSuperviserListSuccess = (successData: any) => ({
	type: AuditingToolActionTypes.GET_ALL_SUPERVISER_LIST_SUCCESS,
	payload: successData,
});

export const getAllSuperviserListFailure = (failureData: any) => ({
	type: AuditingToolActionTypes.GET_ALL_SUPERVISER_LIST_FAILURE,
	payload: failureData,
});

export const getAllSuperviserListReset = () => ({
	type: AuditingToolActionTypes.GET_ALL_SUPERVISER_LIST_RESET,
});

export const getAllSuperviserListChanged = () => ({
	type: AuditingToolActionTypes.GET_ALL_SUPERVISER_LIST_CHANGED,
});
/** ***************** GET SUPERVISER LIST END *********************** */

/** ***************** APPROVE TRAINING PROPOSAL START *********************** */
export const approveTrainingProposalStart = (rejectData: any) => ({
	type: AuditingToolActionTypes.APPROVE_TRAINING_PROPOSAL_START,
	payload: rejectData,
});

export const approveTrainingProposalSuccess = (successData: any) => ({
	type: AuditingToolActionTypes.APPROVE_TRAINING_PROPOSAL_SUCCESS,
	payload: successData,
});

export const approveTrainingProposalFailure = (failureData: any) => ({
	type: AuditingToolActionTypes.APPROVE_TRAINING_PROPOSAL_FAILURE,
	payload: failureData,
});

export const approveTrainingProposalReset = () => ({
	type: AuditingToolActionTypes.APPROVE_TRAINING_PROPOSAL_RESET,
});

export const approveTrainingProposalChanged = () => ({
	type: AuditingToolActionTypes.APPROVE_TRAINING_PROPOSAL_CHANGED,
});
/** ***************** APPROVE TRAINING PROPOSAL END *********************** */

/** ***************** GET TRAINING PROPOSAL INDIVIDUAL START *********************** */
export const getTrainingProposalIndividualStart = (getData: any) => ({
	type: AuditingToolActionTypes.GET_TRAINING_PROPOSAL_INDIVIDUAL_START,
	payload: getData,
});

export const getTrainingProposalIndividualSuccess = (successData: any) => ({
	type: AuditingToolActionTypes.GET_TRAINING_PROPOSAL_INDIVIDUAL_SUCCESS,
	payload: successData,
});

export const getTrainingProposalIndividualFailure = (failureData: any) => ({
	type: AuditingToolActionTypes.GET_TRAINING_PROPOSAL_INDIVIDUAL_FAILURE,
	payload: failureData,
});

export const getTrainingProposalIndividualReset = () => ({
	type: AuditingToolActionTypes.GET_TRAINING_PROPOSAL_INDIVIDUAL_RESET,
});

export const getTrainingProposalIndividualChanged = () => ({
	type: AuditingToolActionTypes.GET_TRAINING_PROPOSAL_INDIVIDUAL_CHANGED,
});
/** ***************** GET TRAINING PROPOSAL INDIVIDUAL END *********************** */

/** ***************** SAVE PHYSICAL DOCS START *********************** */
export const savePhysicalDocsStart = (payload: any) => ({
	type: AuditingToolActionTypes.SAVE_PHYSICAL_DOCS_START,
	payload,
});

export const savePhysicalDocsSuccess = (response: any) => ({
	type: AuditingToolActionTypes.SAVE_PHYSICAL_DOCS_SUCCESS,
	payload: response,
});

export const savePhysicalDocsFailure = (error: any) => ({
	type: AuditingToolActionTypes.SAVE_PHYSICAL_DOCS_FAILURE,
	payload: error,
});

export const savePhysicalDocsReset = () => ({
	type: AuditingToolActionTypes.SAVE_PHYSICAL_DOCS_RESET,
});

export const savePhysicalDocsChanged = () => ({
	type: AuditingToolActionTypes.SAVE_PHYSICAL_DOCS_CHANGED,
});
/** ***************** SAVE PHYSICAL DOCS END *********************** */

/** ***************** SAVE DIGITAL DOCS START *********************** */
export const saveDigitalDocsStart = (payload: any) => ({
	type: AuditingToolActionTypes.SAVE_DIGITAL_DOCS_START,
	payload,
});

export const saveDigitalDocsSuccess = (response: any) => ({
	type: AuditingToolActionTypes.SAVE_DIGITAL_DOCS_SUCCESS,
	payload: response,
});

export const saveDigitalDocsFailure = (error: any) => ({
	type: AuditingToolActionTypes.SAVE_DIGITAL_DOCS_FAILURE,
	payload: error,
});

export const saveDigitalDocsReset = () => ({
	type: AuditingToolActionTypes.SAVE_DIGITAL_DOCS_RESET,
});

export const saveDigitalDocsChanged = () => ({
	type: AuditingToolActionTypes.SAVE_DIGITAL_DOCS_CHANGED,
});
/** ***************** SAVE DIGITAL DOCS END *********************** */

/** ***************** RE-AUDIT PROPOSAL START *********************** */
export const reAuditProposalStart = (payload: any) => ({
	type: AuditingToolActionTypes.RE_AUDIT_PROPOSAL_START,
	payload,
});

export const reAuditProposalSuccess = (response: any) => ({
	type: AuditingToolActionTypes.RE_AUDIT_PROPOSAL_SUCCESS,
	payload: response,
});

export const reAuditProposalFailure = (error: any) => ({
	type: AuditingToolActionTypes.RE_AUDIT_PROPOSAL_FAILURE,
	payload: error,
});

export const reAuditProposalReset = () => ({
	type: AuditingToolActionTypes.RE_AUDIT_PROPOSAL_RESET,
});

export const reAuditProposalChanged = () => ({
	type: AuditingToolActionTypes.RE_AUDIT_PROPOSAL_CHANGED,
});
/** ***************** RE-AUDIT PROPOSAL END *********************** */

/** ***************** GET MEMBER AUDIT ANSWERS START *********************** */
export const getMemberAuditAnswersStart = (payload: any) => ({
	type: AuditingToolActionTypes.GET_MEMBER_AUDIT_ANSWERS_START,
	payload,
});

export const getMemberAuditAnswersSuccess = (response: any) => ({
	type: AuditingToolActionTypes.GET_MEMBER_AUDIT_ANSWERS_SUCCESS,
	payload: response,
});

export const getMemberAuditAnswersFailure = (error: any) => ({
	type: AuditingToolActionTypes.GET_MEMBER_AUDIT_ANSWERS_FAILURE,
	payload: error,
});

export const getMemberAuditAnswersReset = () => ({
	type: AuditingToolActionTypes.GET_MEMBER_AUDIT_ANSWERS_RESET,
});

export const getMemberAuditAnswersChanged = () => ({
	type: AuditingToolActionTypes.GET_MEMBER_AUDIT_ANSWERS_CHANGED,
});
/** ***************** GET MEMBER AUDIT ANSWERS END *********************** */
